import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-musaffa-score',
    templateUrl: './musaffa-score.component.html',
    styleUrls: ['./musaffa-score.component.scss'],
    standalone: false
})
export class MusaffaScoreComponent implements OnInit {
   isShareLinksVisible = false;
   isIRIReport: boolean = true;
   @Input() musaffaData: any;
   @Input() isSample: boolean = false;
   constructor() { }

   ngOnInit(): void {
   }

   getScoreClass(score?: string | null): string {
      if (!score) return '';
      switch (score) {
         case 'Poor':
            return 'score-poor';
         case 'Weak':
            return 'score-weak';
         case 'Fair':
            return 'score-fair';
         case 'Good':
            return 'score-good';
         case 'Excellent':
            return 'score-excellent';
         default:
            return '';
      }
   }

   toggleVisibility() {
      this.isShareLinksVisible = !this.isShareLinksVisible
   }

   open() {
      this.isShareLinksVisible = true;
   }

   close() {
      this.isShareLinksVisible = false;
   }

}
